import { findIndex } from 'lodash';

export function addOrUpdateItem<T>(
  existingItems: T[],
  newItem: T,
  findPredicate: (oldItem: T) => boolean,
  updaterFn: (oldItem: T, newItem: T) => T
) {
  const existingMemberIndex = findIndex(existingItems, findPredicate);

  if (existingMemberIndex === -1) {
    return [...existingItems, newItem];
  }

  const updatedMembers = [...existingItems];
  updatedMembers[existingMemberIndex] = updaterFn(
    updatedMembers[existingMemberIndex],
    newItem
  );

  return updatedMembers;
}
